import type { DebtDto, LoanDto } from '@signalvote/shared';
import type { Read } from '@signalvote/data';

const NO_LOANS: LoanDto[] = [];
const NO_DEBTS: DebtDto[] = [];

/** The loans once their read has answered; none while it loads or could not answer. */
export function loanRows(read: Read<LoanDto[]>): LoanDto[] {
  return read.status === 'ready' || read.status === 'placeholder' ? read.data : NO_LOANS;
}

/** The debts once their read has answered; none while it loads or could not answer. */
export function debtRows(read: Read<DebtDto[]>): DebtDto[] {
  return read.status === 'ready' || read.status === 'placeholder' ? read.data : NO_DEBTS;
}

/** What to say in place of the loans when their read could not answer; null otherwise. */
export function loansUnreadyMessage(read: { status: string }): string | null {
  if (read.status === 'failed') return "Couldn't load loans. Refresh to try again.";
  if (read.status === 'offline') return "You're offline, so loans can't load.";
  return null;
}

/** What to say in place of the debts when their read could not answer; null otherwise. */
export function debtsUnreadyMessage(read: { status: string }): string | null {
  if (read.status === 'failed') return "Couldn't load debts. Refresh to try again.";
  if (read.status === 'offline') return "You're offline, so debts can't load.";
  return null;
}
